import { Table } from "@/features/Table";
import { type AdminUserAction, admin_user_actions_columns } from "./columns";
import {
  type FilterAdminUserActionSchema,
  FilterAdminUserAction,
} from "./filter";

const client = "etl-quantilia";
const table_name = "admin_user_actions";

export const AdminUserActionsTable = () => {
  return (
    <Table<AdminUserAction, FilterAdminUserActionSchema>
      label="Admin User Actions"
      client={client}
      table_name={table_name}
      columns={admin_user_actions_columns}
      filter={<FilterAdminUserAction />}
      disable_translations_request={true}
    />
  );
};
